import { ENTITIES } from "../../actions/actionConstants.js";
import { ENDPOINTS } from "../../../constants/api.js";
import { getEntities } from "../../actions/actionUtils.js";

// -- IMAGE ACTIONS -- //

export function getImages(searchParams, dependencies) {
  return getEntities(ENTITIES, ENDPOINTS.IMAGES, dependencies, searchParams);
}
